import { Component, OnInit, Input } from '@angular/core'
import { ValidatedRadioButtonModel } from '../../../../validations/validated-radio-button-group.component'
import { Router } from '@angular/router'
import { EnrollmentViewModel } from '../../../models/enrollment-view-model'
import { stcobModel } from '../../../models/stcob-model'
import { EnrollmentGateway } from '../../../gateways/enrollment-gateway'
import { PortalGlobals } from '../../../../portalglobals'
import * as moment from 'moment'
import { CurrentUserGateway } from '../../../../common/gateways/current-user-gateway'
import { GetEnrollmentDataResponse, GetEnrollmentDataByID } from '../../../models/get-enrollment-data-response'
import { EnrollmentCacheData } from '../../../models/EnrollmentCacheData'

@Component({
    selector: 'NEJEPhoneEnrollmentStep3',
    templateUrl: 'phone-enrollment-step3.component.html',
    styleUrls: ['./phone-enrollment.component.scss']
})
export class NEJEPhoneEnrollmentStep3Component implements OnInit {
    public rblAgreement: ValidatedRadioButtonModel[] = []
    public rblValidInfo: ValidatedRadioButtonModel[] = []
    enrollmentViewModel: EnrollmentViewModel = new EnrollmentViewModel()
    public CurrentDate: string
    public BenefName: string
    public agentName: string
    effectiveDate: string
    isQtip: boolean
    planName: string
    public showContinue: boolean
    public y1: boolean
    public y2: boolean
    public y3: boolean
    public y4: boolean
    public y5: boolean
    public y6: boolean
    public y7: boolean
    public y8: boolean
    public Script2023: boolean

    insuranceComapny: string
    spnIsBeneficiary: string
    spnhimher: string
    enrollmentCacheData: EnrollmentCacheData = {} as EnrollmentCacheData
    getEnrollmentDataResponse: GetEnrollmentDataResponse = new GetEnrollmentDataResponse()

    constructor(
        private _enrollementGateway: EnrollmentGateway,
        public _global: PortalGlobals,
        private router: Router,
        private _currentUserGateway: CurrentUserGateway
    ) {
        this.rblAgreement.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.isQtip = false
    }
    ngOnInit() {
        if (Number(this._global.selectedPlanYear) === this._global.Planyear2023) {
            this.Script2023 = true
        }
        if (this._global === undefined || this._global.currentUser === undefined) {
            this._currentUserGateway.getCurrentUser().subscribe((user) => {
                if (user != null) {
                    this._global.currentUser = user
                    this.insuranceComapny = this._global.currentUser.insuranceCompanyName
                }
            })
        }
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        if (this._global.currentUser !== undefined) {
            this.insuranceComapny = this._global.currentUser.insuranceCompanyName
        }
        this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModel()

        if (this.enrollmentViewModel === null || this.enrollmentViewModel === undefined) {
            this.router.navigate(['/' + insCo + '/enrollment/neje/phone-enrollment/Step1'])
        }

        if (this.enrollmentViewModel.AGENTID === null || this.enrollmentViewModel.AGENTID === undefined || this.enrollmentViewModel.AGENTID === '') {
            if (sessionStorage.getItem('EnrollmentCache') != null) {
                this.enrollmentCacheData = JSON.parse(sessionStorage.getItem('EnrollmentCache')!)

                this._enrollementGateway.getEnrollmentDataByKey(this.enrollmentCacheData.EnrollmentKey).subscribe(
                    (getEnrollmentDataResponse: GetEnrollmentDataResponse) => {
                        this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModelByKey(getEnrollmentDataResponse)
                        this.enrollmentViewModel.ENROLLKEY = this.enrollmentCacheData.EnrollmentKey
                        this.enrollmentViewModel.ADMINID = this.enrollmentCacheData.AdminID
                        this.enrollmentViewModel.AGENTORGID = this.enrollmentCacheData.AgentOrgID
                        this.enrollmentViewModel.AGENTNAME = this.enrollmentCacheData.AgentName
                        this.enrollmentViewModel.PLANTYPENAME = this.enrollmentCacheData.PLANTYPENAME
                        this.enrollmentViewModel.USERNAME = this.enrollmentCacheData.USERNAME
                        this.enrollmentViewModel.ISSTCOB = this.enrollmentCacheData.ISSTCOB
                        this.enrollmentViewModel.SINGLEGRPNAME = this.enrollmentCacheData.GroupPlanName

                        this.LoadData()
                    },
                    (err) => {}
                )
            } else {
                this.router.navigate(['/' + insCo + '/enrollment/neje/phone-enrollment/Step1'])
            }
        } else {
            this.LoadData()
        }
    }

    LoadData(): void {
        this.BenefName = this.enrollmentViewModel.APPFN + ' ' + this.enrollmentViewModel.APPLN
        this.agentName = this._global.currentUser.firstName
        this.planName = this.enrollmentViewModel.PLANTYPENAME
        if (this.enrollmentViewModel !== undefined && this.enrollmentViewModel.EFFDT !== undefined) {
            this.effectiveDate = moment(this.enrollmentViewModel.EFFDT).format('MM/DD/YYYY')
        }
        this.setScript()

        this.showContinue = false
        this.y1 = false
        this.y2 = false
        this.y3 = false
        this.y4 = false
        this.y5 = false
        this.y6 = false
        this.y7 = false
        this.y8 = false

        this.CurrentDate = moment().format('MM/DD/YYYY')
        if (
            this.enrollmentViewModel.CALLOGID !== null &&
            this.enrollmentViewModel.CALLOGID !== undefined &&
            this.enrollmentViewModel.CALLOGID !== 0
        ) {
            this.isQtip = true
        }

        this.SelectYesNoChange(this.enrollmentViewModel.y1, 'y1')
        this.SelectYesNoChange(this.enrollmentViewModel.y2, 'y2')
        this.SelectYesNoChange(this.enrollmentViewModel.y3, 'y3')
        this.SelectYesNoChange(this.enrollmentViewModel.y4, 'y4')
        this.SelectYesNoChange(this.enrollmentViewModel.y5, 'y5')
        this.SelectYesNoChange(this.enrollmentViewModel.y6, 'y6')
        this.SelectYesNoChange(this.enrollmentViewModel.y7, 'y7')
        this.SelectYesNoChange(this.enrollmentViewModel.y8, 'y8')
    }

    setValue(value: string): boolean {
        if (value === 'Yes') {
            return true
        }
        if (value === 'No') {
            return false
        }
        return false
    }

    SubmitYesNO(isYesNo: string) {}

    SelectYesNoChange(isYesNo: string, controlID: string) {
        if (controlID === 'y1') {
            this.y1 = this.setValue(isYesNo)
            this.enrollmentViewModel.y1 = isYesNo
        }
        if (controlID === 'y2') {
            this.y2 = this.setValue(isYesNo)
            this.enrollmentViewModel.y2 = isYesNo
        }
        if (controlID === 'y3') {
            this.y3 = this.setValue(isYesNo)
            this.enrollmentViewModel.y3 = isYesNo
        }
        if (controlID === 'y4') {
            this.y4 = this.setValue(isYesNo)
            this.enrollmentViewModel.y4 = isYesNo
        }
        if (controlID === 'y5') {
            this.y5 = this.setValue(isYesNo)
            this.enrollmentViewModel.y5 = isYesNo
        }
        if (controlID === 'y6') {
            this.y6 = this.setValue(isYesNo)
            this.enrollmentViewModel.y6 = isYesNo
        }
        if (controlID === 'y7') {
            this.y7 = this.setValue(isYesNo)
            this.enrollmentViewModel.y7 = isYesNo
        }
        if (controlID === 'y8') {
            this.y8 = this.setValue(isYesNo)
            this.enrollmentViewModel.y8 = isYesNo
        }

        if (this.y1 && this.y2 && this.y3 && this.y4 && this.y5 && this.y6 && this.y7 && this.y8) {
            if (isYesNo === 'Yes') {
                this.showContinue = true
            }
            if (isYesNo === 'No') {
                this.showContinue = false
            }
        } else {
            this.showContinue = false
        }
    }

    onBack(): void {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/neje/phone-enrollment/Step2'])
    }
    formSubmit(): void {
        this.enrollmentViewModel.SUBMISSIONTYPECODE = 'PROSPECT'
        this.enrollmentViewModel.STEPCODE = '3'
        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/neje/phone-enrollment/Preview'])
    }
    keyDownFunction(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.formSubmit()
        }
    }
    setScript() {
        this.spnhimher = '(him, her)'
        if (this.enrollmentViewModel.RBLBENFE === 'Yes') {
            this.spnIsBeneficiary = 'your'
        }
        if (this.enrollmentViewModel.RBLBENFE === 'No' && this.BenefName !== ' ' && this.BenefName !== 'undefined undefined') {
            this.spnIsBeneficiary = this.BenefName + '’s'
        }
        if (this.enrollmentViewModel.RBLBENFE === 'No' && (this.BenefName === ' ' || this.BenefName === 'undefined undefined')) {
            this.spnIsBeneficiary = '(your, enrollee’s name)'
        }
        if (this.enrollmentViewModel.APPGEN === 'F') {
            this.spnhimher = 'her'
        }
        if (this.enrollmentViewModel.APPGEN === 'M') {
            this.spnhimher = 'him'
        }
    }
}
